export default "__VITE_ASSET__CqGB7oaz__"